import React from 'react';
import PropTypes from 'prop-types';
import componentBase from '../../../src/lib/component-base';
import { prefersAMPMTimeFormat } from '../../../src/lib/date-time-format';

const planeOrangeIcon = require('../../../static/images/plane-orange.svg');

@componentBase('FlightAlertsDetailHeader')
export default class FlightAlertsDetailHeader extends React.Component {
  static propTypes = {
    containerClassName: PropTypes.string,
    flightInfo: PropTypes.object,
  }

  render() {
    // this.logger('props: ', this.props, 'state: ', this.state);
    const depTime = prefersAMPMTimeFormat(this.context.currentUser) ? this.props.flightInfo.departureTime : this.props.flightInfo.departureTime24;
    const depTimeAMPM = prefersAMPMTimeFormat(this.context.currentUser) ? this.props.flightInfo.departureTimeMeridian : null;

    const arrTime = prefersAMPMTimeFormat(this.context.currentUser) ? this.props.flightInfo.arrivalTime : this.props.flightInfo.arrivalTime24;
    const arrTimeAMPM = prefersAMPMTimeFormat(this.context.currentUser) ? this.props.flightInfo.arrivalTimeMeridian : null;
    const arrivalAirportRegion = this.props.flightInfo.arrivalAirport.airportStateCode &&
                                this.props.flightInfo.arrivalAirport.airportStateCode.length > 0 ? `${this.props.flightInfo.arrivalAirport.airportStateCode},` : '';
    const departureAirportRegion = this.props.flightInfo.departureAirport.airportStateCode &&
                                this.props.flightInfo.departureAirport.airportStateCode.length > 0 ? `${this.props.flightInfo.departureAirport.airportStateCode},` : '';

    return (
      <div className={`flight-alerts-detail-header-container ${this.props.containerClassName || ''}`}>
        <div className={`flight-info-header-group ${this.props.containerClassName || ''}`}>
          <p className='flight-info-header'>Origin</p>
          <p className='flight-info-header'>Destination</p>
          <p className='flight-info-header'>Departure Time</p>
          <p className='flight-info-header'>Arrival Time</p>
        </div>
        <div className={`flight-info-chart ${this.props.containerClassName || ''}`}>
          <div className='info-pack-group'>
            <p className='flight-info-cell-alert'>{this.props.flightInfo.departureAirportFsCode || this.props.flightInfo.departureAirport.code}</p>
            <p className='flight-info-cell-alert'>{this.props.flightInfo.arrivalAirportFsCode || this.props.flightInfo.arrivalAirport.code}</p>
            <div className='time-info-group'>
              <p className='time-info-cell-alert'><span className='time-span-alert'>{depTime}</span> <span className='time-info-span'> {depTimeAMPM} {this.props.flightInfo.departureTimeZone}</span></p>
              <p className='time-info-cell-alert'><span className='time-span-alert'>{arrTime}</span> <span className='time-info-span'> {arrTimeAMPM} {this.props.flightInfo.arrivalTimeZone}</span></p>
            </div>
          </div>
          <div className='info-pack-group row'>
            <div className='col-xs-5'>
              <p className='flight-info-pack'>
                <span className='flight-info-span' style={{ display: 'block' }}>
                  {this.props.flightInfo.departureAirport.airportName}
                </span>
                <span className='flight-info-span' style={{ display: 'block' }}>
                  {`${this.props.flightInfo.departureAirport.airportCityName}, ${departureAirportRegion} ${this.props.flightInfo.departureAirport.airportCountryName}`}
                </span>
              </p>
            </div>
            <div className='col-xs-2'>
              <div className='flight-info-icon'>
                <img alt='flying plane icon' src={planeOrangeIcon} />
              </div>
            </div>
            <div className='col-xs-5'>
              <p className='flight-info-pack'>
                <span className='flight-info-span' style={{ display: 'block' }}>
                  {this.props.flightInfo.arrivalAirport.airportName}
                </span>
                <span className='flight-info-span' style={{ display: 'block' }}>
                  {`${this.props.flightInfo.arrivalAirport.airportCityName}, ${arrivalAirportRegion} ${this.props.flightInfo.arrivalAirport.airportCountryName}`}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/components/FlightAlertsDetailHeader/FlightAlertsDetailHeader.js